import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { partialUpdateOrg as apiUpdateOrg } from 'api/orgAdmin';
import { Org } from 'api/orgs';
import SearchContextHeaderContainer from 'containers/SearchContextHeaderContainer';
import { trackPageView } from 'utils/analytics';
import { scrollToHash } from 'utils/scrollIntoView';

import { fetchOrg, partialUpdateOrg } from '../redux/main/slices/orgs';
import { setDocumentTitle } from '../utils/meta';
import ListingUnpublishedPage from './ListingUnpublishedPage';
import LoadingPage from './LoadingPage';
import OrgPage from './OrgPage';

const trackOrg = ({ name, id, orgType }: Org) => {
  trackPageView('Org Listing Page', {
    name,
    id,
    org_type: orgType,
    page_type: 'Org Listings',
  });
};

type Props = {
  orgId: string;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const OrgPageContainer = ({ orgId }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentUser, org } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
    currentUser: state.currentUser,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'orgs' does not exist on type 'DefaultRoo... Remove this comment to see the full error message
    org: state.orgs.byId[orgId],
  }));
  useEffect(() => {
    if (!org) {
      dispatch(fetchOrg(orgId));
    }

    if (org && !org.isFetching && !org.isUnpublished) {
      trackOrg(org);
      setDocumentTitle(org.name);
    }

    scrollToHash(location.hash.replace('section-', ''));
  }, [dispatch, location.hash, org, orgId]);

  const onSubmit = ({
    values,
    handleError,
  }: {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError: (...args: Array<any>) => any;
  }) => {
    apiUpdateOrg(values)
      .then(() => {
        dispatch(partialUpdateOrg(values));
      })
      .catch(handleError);
  };

  if (!org || org.isFetching) {
    return <LoadingPage />;
  }

  return (
    <SearchContextHeaderContainer
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ currentObjectId: string; render: (searchCo... Remove this comment to see the full error message
      currentObjectId={orgId}
      render={(searchContext) => {
        if (!org.isFetching && org.isUnpublished) {
          return (
            <ListingUnpublishedPage
              adminType="ORG"
              listingType="ORG"
              searchContext={searchContext}
            />
          );
        }

        return (
          <OrgPage
            org={org}
            searchContext={searchContext}
            currentUser={currentUser}
            isPublished
            onSubmit={onSubmit}
          />
        );
      }}
    />
  );
};

export default OrgPageContainer;
